import { Box, Stack, Typography } from '@mui/material';
import { visuallyHidden } from '@mui/utils';

import { TextInput } from '@/components/form/baseInputs/TextInput/TextInput';
import { Badge, BadgeVariants } from '@/components/notifications/Badge/Badge';

import { getValidationQuestions } from './validationQuestions.utils';

export function ValidationQuestion({
  question,
  number,
  value,
  disabled,
  onChange,
}: {
  question: ReturnType<typeof getValidationQuestions>[number];
  number: number;
  value: string;
  disabled: boolean;
  onChange: (value: string) => void;
}) {
  return (
    <Stack direction="row" spacing={1}>
      <Badge
        variant={BadgeVariants.SecondaryOutline}
        display={number}
        sx={{ minWidth: 18, px: 0, py: '1px' }}
        wrapperSx={{ flexShrink: 0 }}
      />
      <Stack spacing={0.5} flex={1} minWidth={0}>
        <Typography variant="body-s">{question.title}</Typography>
        {question.subtitle && (
          <Typography variant="body-xs">{question.subtitle}</Typography>
        )}
        <TextInput
          label={
            <Box
              component="span"
              sx={visuallyHidden}
            >{`Response to ${question.title}`}</Box>
          }
          placeholder="Type your response…"
          multiline
          minRows={1}
          sx={{
            '& .MuiInputBase-inputMultiline': {
              // Keep padding inside the textarea width. Only the modal scrolls.
              boxSizing: 'border-box',
              overflowWrap: 'anywhere',
              overflow: 'hidden',
            },
          }}
          value={value}
          disabled={disabled}
          onChange={(event) => onChange(event.target.value)}
        />
      </Stack>
    </Stack>
  );
}
